define([
    'text!product-detail2024/page/page-content.html',
    'product-detail2024/page/furniture-page-content',
    'product-detail2024/page/ymb-page-content',
    'product-detail2024/page/grocery-page-content',
    'product-detail2024/page/gallery-page-content',

    'common/api',
    'common/utils',
    'product-detail/store'
], function(
    tpl,
    FurniturePageContent,
    YmbPageContent,
    GroceryPageContent,
    GalleryPageContent,
    Api,
    Utils,
    Store
){
    return {
        template: tpl,
        components: {
            FurniturePageContent: FurniturePageContent,
            YmbPageContent: YmbPageContent,
            GroceryPageContent: GroceryPageContent,
            GalleryPageContent: GalleryPageContent

        },
        data: function(){
            return {
                product: {}
            };
        },
        computed: {
            category: function(){
                return this.product.category || '';
            },
            isFurniture: function(){
                return this.category === 'furniture';
            },
            isYmb: function(){
                return this.category === 'ymb';
            },
            isGrocery: function(){
                return this.category === 'grocery';
            },
            isGallery: function(){
                return this.category === 'gallery';
            }
        },
        methods: {
            // fetchProductDetail: function(){
            //     var id = this.$route.query.id;
            //     if (!id){
            //         return alert('缺少页面参数[id]');
            //     }
            //     var preview = this.$route.query.preview || 0;
            //     var isTmType = this.$route.query.isTmType || 0;
            //     var _this = this;
            //
            //     Api.getProductDetailApi.ajax({id: id, preview: preview, isTmType: isTmType})
            //         .done(function(data){
            //             _this.product = Store.setProduct(data);
            //             console.log(data);
            //             Utils.emitPageReady();
            //         });
            // }
        },
        created: function(){
            // this.fetchProductDetail();
        },
        watch: {
            '$i18n.locale': function () {
                // this.fetchProductDetail();
            }
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./product-detail2024/page/page-content.js
// module id = 193
// module chunks = 0